import * as yup from 'yup';

import {
  confirmPasswordFieldSchema,
  newPasswordFieldSchema,
} from 'schemas/passwordRules';

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .required('Введите email или телефон')
    .test('email-or-phone', 'Неверный формат email или телефона', (value) => {
      const text = (value || '').trim();
      if (!text) return false;
      if (text.includes('@')) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text);
      }
      const digits = text.replace(/\D/g, '');
      return digits.length >= 10 && digits.length <= 11;
    }),
});

export const resetPasswordSchema = yup.object({
  password: newPasswordFieldSchema({ requiredMessage: 'Введите пароль' }),
  confirmPassword: confirmPasswordFieldSchema('password'),
});
